import { settings } from '../../../settings/settings-util'
import reducer from './reducers/index'
import objectPath from 'object-path'
import LiveChatState from '../../livechat-foundation/src/livechat-state'
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';
import {
    resetSessionId,
    clearHistoryInState,
    clearHistoryInAgent,
    addNotificationMessage,
    showTimeoutWarning,
    hideTimeoutWarning,
    setSessionStartTime,
    refreshPersistedState,
    setInactivityTime
} from '../../lib-end-session/lib/lib-end-session'
import {
    isLiveChat,
} from '../../lib-livechat/lib/lib-livechat'
import watch from 'redux-watch';
import * as Actions from './actions/actions';
import {enableInputBox, disableInputBox} from '../../lib-inputbox-toggle/lib/lib-inputbox-toggle';
export default class RequestProcessorEndSession {
    //#region Public Interface

    constructor(passedSettings, initialize = null) {
        this._settings = passedSettings || settings;
        this._inactivityTimerId = null;
        this._sessionTimerId = null;
        this._warningTimerId = null;
        this._promiseResolved = false;
        this.isLiveChat = isLiveChat;
        this.resetSessionId = resetSessionId;
        this.clearHistoryInState = clearHistoryInState;
        this.clearHistoryInAgent = clearHistoryInAgent;
        this.addNotificationMessage = addNotificationMessage;
        this.hideTimeoutWarning = hideTimeoutWarning;
        this.setSessionStartTime = setSessionStartTime;
        this.showTimeoutWarning = showTimeoutWarning;
        this.refreshPersistedState = refreshPersistedState;
        this.setInactivityTime = setInactivityTime;
        this._liveChatState = new LiveChatState(this._settings);
        this._ignoreTimeout = false;
        this._initialize = initialize;
    }

    static getDefaultSettings() {
        return settings;
    }

    async initialize(store, initializationPromises) {
        this._store = store;
        this._initializationPromises = initializationPromises;
        await this._initializationPromises?.onLaunch;
        this._promiseResolved = true;
        this.setInactivityTimer();
        this.resetSessionTimers();
        let conversationBaseLocation = this._settings.stateLocations.Conversation.Base;
        let processedResponseLocation = this._settings.stateLocations.Conversation.processedResponse;

        let watcher = watch(this._store.getState, `${conversationBaseLocation}.${processedResponseLocation}`);
        this._store.subscribe(watcher((newVal, oldVal, objectPath) => {
            return this.handleProcessedResponse(newVal, oldVal, objectPath);
        }));
    }
    handleProcessedResponse(newVal, oldVal, objectPath) {
        if (!(this.doesHandle(newVal) && this.containsIgnoredResponseAction(newVal))) return;

        let stateLocation = this._settings.stateLocations.AutoNav.stagedNav;
    }

    doesHandle(message) {
        let handles = false;
        if (message) {
            handles = (message.messageType === this._settings.messageConstants.converseRequest) ||
                (message.messageType === this._settings.messageConstants.requestUnitRequest) ||
                (message.messageType === this._settings.messageConstants.appeventRequest);
        }
        return handles;
    }

    containsIgnoredResponseAction(message) {
        this._ignoreTimeout = false;
        if (message.response && message.response.responseActions && message.response.responseActions.length > 0) {
            if (this._settings.ignoreTimeoutResponseActions.responseActionValues.includes(message.response.responseActions[0].Name)) {
                this._ignoreTimeout = true;
            }
        }
        return this._ignoreTimeout;
    }
    getReducer() {
        return reducer;
    }

    process(message) {
        if (!this._promiseResolved || this._settings.endSession.ignoreEventName.includes(message.eventName) ||
            this._settings.endSession.ignoreMessageSource.includes(message.messageSource)) {

            return message;
        }
        let isActiveSession = objectPath.get(this._store.getState(), `${this._settings.stateLocations.Conversation.Base}.${this._settings.stateLocations.Conversation.isActiveSession}`);

        if (isActiveSession && !this._inactivityTimerId) {
            this.setInactivityTimer();
        }

        if (message.messageType === this._settings.messageConstants.getHistoryRequest && isActiveSession) {
            this.resetAllTimers();
            return message;
        }

        this.resetSessionTimers();

        return message;
    }

    //#endregion



    //#region Timer Methods

    resetAllTimers() {
        let sessionStartTime = this.getSessionStartTime();
        let inactivityTime = this.getInactivityTime();

        if (isNaN(sessionStartTime) || isNaN(inactivityTime)) {
            this.resetSessionTimers();

            return;
        }

        let delay = (this._settings.Alme || loadedSettings || {}).ClientSessionTimeout;
        let warningOffset = (this._settings.Alme || loadedSettings || {}).ClientSessionTimeoutWarning;

        if (!delay || !warningOffset) { return; }

        let remainingDelay = this.minutesToMs(delay) - (inactivityTime - sessionStartTime);
        let warningDelay = remainingDelay - this.minutesToMs(warningOffset);

        if (warningDelay > 0) {
            this.setTimeoutWarningTimer(warningDelay);
        }
        else {
            this.setAriaHidden();
            this.showTimeoutWarning(this._store, this._settings);
        }

        this.setSessionTimeoutTimer(remainingDelay);

    }

    resetSessionTimers() {
        clearTimeout(this._sessionTimerId);
        clearTimeout(this._warningTimerId);

        let currentTime = new Date();
        this.setSessionStartTime(currentTime.toJSON(), this._store, this._settings);

        let delay = (this._settings.Alme || {}).ClientSessionTimeout;
        let warningOffset = (this._settings.Alme || {}).ClientSessionTimeoutWarning;

        if (!delay || !warningOffset) { return; }

        let warningDelayMs = this.minutesToMs(delay - warningOffset);

        this.setTimeoutWarningTimer(warningDelayMs);
        this.setSessionTimeoutTimer(this.minutesToMs(delay));

    }

    setInactivityTimer() {

        this._inactivityTimerId = setInterval(() => {
            this.refreshPersistedState(this._store, this._settings);

            let currentTime = new Date();

            if (!this.isLiveChat(this._store, this._settings) && !this._ignoreTimeout && !settings.timeoutWarning.isDisabled) {
                this.setInactivityTime(currentTime.toJSON(), this._store, this._settings);
            }


        }, this._settings.Alme.ClientSessionInactivityMs);

    }

    setTimeoutWarningTimer(warningDelayMs) {

        this._warningTimerId = setTimeout(() => {
            this.refreshPersistedState(this._store, this._settings);

            let sessionStartDate = this.getSessionStartTime();
            let rightNow = new Date();
            let remainder = rightNow - sessionStartDate;

            let delay = (this._settings.Alme || {}).ClientSessionTimeout;
            let warningOffset = (this._settings.Alme || {}).ClientSessionTimeoutWarning;

            let timeTillWarningInSession = this.minutesToMs(delay - warningOffset);

            if (!this.isLiveChat(this._store, this._settings) && !this._ignoreTimeout && !settings.timeoutWarning.isDisabled) {
                if (isNaN(sessionStartDate) || remainder > timeTillWarningInSession) {
                    this.setAriaHidden();
                    this.showTimeoutWarning(this._store, this._settings);
                }
                else {
                    this.setTimeoutWarningTimer(timeTillWarningInSession - remainder);
                }
            }


        }, warningDelayMs);

    }

    setSessionTimeoutTimer(timeTillSessionEndsMs) {

        this._sessionTimerId = setTimeout(() => {
            this.refreshPersistedState(this._store, this._settings);

            let sessionStartDate = this.getSessionStartTime();
            let rightNow = new Date();
            let remainder = rightNow - sessionStartDate;

            let delay = (this._settings.Alme || {}).ClientSessionTimeout;
            let warningOffset = (this._settings.Alme || {}).ClientSessionTimeoutWarning;

            let timeTillWarningInSession = this.minutesToMs(delay - warningOffset);
            let timeTillSessionExpires = this.minutesToMs(delay);

            if (!this.isLiveChat(this._store, this._settings) && !this._ignoreTimeout) {
                if (isNaN(sessionStartDate) || remainder > timeTillSessionExpires) {

                    this.resetSessionId(this._store, this._settings);
                    this.clearHistoryInState(this._store, this._settings);
                    this.clearHistoryInAgent(this._settings);
                    // Reset the IVA after session has ended.
                    this.hideTimeoutWarning(this._store, this._settings);
                    this.setSessionStartTime("", this._store, this._settings);
                    if(this._settings.timeoutWarning.minimizeOnTimeout){
                        this._store?.dispatch(Actions.setMinimize(true, this._settings.stateLocations.Window.IsMinimized));
                        if(this._initialize !== null){
                            this._initialize.startApplicationInitialize();
                        }
                    }
                    else{
                        this.addNotificationMessage(this._store, this._settings);
                    }
                    this.removeAriaHidden();
                    enableInputBox(this._store, this._settings, () => true);
                }
                else {
                    this.setSessionTimeoutTimer(timeTillSessionExpires - remainder);
                    this.setTimeoutWarningTimer(timeTillWarningInSession - remainder);
                    this.hideTimeoutWarning(this._store, this._settings);
                    this.removeAriaHidden();
                }

            }
        }, timeTillSessionEndsMs);
    }

    buildMinimizeOnClick() {
        
        const { IsMinimized } = this._settings.stateLocations.Window;
        const { reportingEventRequest } = this._settings.messageConstants;

        this._store?.dispatch(Actions.setMinimize(true, IsMinimized));

        const input = {
            eventName: 'MinimizedClicked',
            eventValue: true,
            messageType: reportingEventRequest,
        };

        sendRequest(input);

        return false;

    }

    //#endregion



    //#region Helper Methods

    getSessionStartTime() {
        return this.getDateFromTimeoutWarningState(this._settings.stateLocations.Window.TimeoutWarning.SessionStartTime);
    }

    getInactivityTime() {
        return this.getDateFromTimeoutWarningState(this._settings.stateLocations.Window.TimeoutWarning.InactivityTime);
    }

    getDateFromTimeoutWarningState(location) {
        let window = this._settings.stateLocations.Window.Base;
        let timeout = this._settings.stateLocations.Window.TimeoutWarning.Base;

        let dateString = objectPath.get(this._store.getState(), `${window}.${timeout}.${location}`);

        return new Date(dateString);
    }

    minutesToMs(minutes) {
        return minutes * 6e4;
    }

    setAriaHidden() {
        let concersationareaelement = document.getElementsByClassName(`${settings.classNames.conversationAreaClassName}`);
        if (concersationareaelement.length > 0) {
            concersationareaelement[0].setAttribute('aria-hidden', true);
        }
        let uidragclass = 'ui-draggable-handle';
        let headerelement = document.getElementsByClassName(`${settings.classNames.headerClassName}`);
        let headerelementwithdrag = document.getElementsByClassName(`${settings.classNames.headerClassName} ${uidragclass}`);
        if (headerelement.length > 0) {
            headerelement[0].setAttribute('aria-hidden', true);
        }
        else if (headerelementwithdrag.length > 0) {
            headerelementwithdrag[0].setAttribute('aria-hidden', true);
        }
    }

    removeAriaHidden() {
        let concersationareaelement = document.getElementsByClassName(`${settings.classNames.conversationAreaClassName}`);
        if (concersationareaelement.length > 0) {
            concersationareaelement[0].removeAttribute('aria-hidden');
        }
        let uidragclass = 'ui-draggable-handle';
        let headerelement = document.getElementsByClassName(`${settings.classNames.headerClassName}`);
        let headerelementwithdrag = document.getElementsByClassName(`${settings.classNames.headerClassName} ${uidragclass}`);
        if (headerelement.length > 0) {
            headerelement[0].removeAttribute('aria-hidden');
        }
        else if (headerelementwithdrag.length > 0) {
            headerelementwithdrag[0].removeAttribute('aria-hidden')
        }
    }
    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/request-processor-end-session/src/request-processor-end-session.js